// extracted by mini-css-extract-plugin
export default {"special_pricing_rule":"styles_special_pricing_rule__rWsHH","name":"styles_name__rVk-X"};